﻿{#if (appConfigJS !== '')}
<LibLoader url={appConfigJS} on:loaded="{onLoaded}" />
{/if}
<script>
  import API from '../store/config';
  import { memberInfo, layoutOption, queryStr, apiConfig, appVer, mode, skipInfo, appSetting, cipherText as cipherTextStore, inappTokenSource } from '../store/inapp-store'
  import { initializeInappAuth, inappFetch, setInappToken, hasValidToken } from '../store/inapp-auth'
  import { getAuthVAsync, screenLight } from '../store/openpoint'
  import { Modal, Loader, Warning, LibLoader } from '../components';

  // 開發測試用網址: http://localhost:5000/home?v=1.0.0&ct=V0Nz2P3T%2FCuLsOO1ZZ%2BPwPTu87b3BLvqyskPqhL1mdM%3D&mode=dev
 
  let appConfigJS = '' //-- 取得系統開放設定JS所在位置
  let validate = false;
  let loader = { content: '服務確認中...' };
  let isBlock = true;
  let warning = { message: [], small: [] };
  let needRefundCount = 0;

  $layoutOption = {
    navTitle: '循環杯',
    navBackUrl: '',
    showCarousel: validate,
    showBanner: false,
    showHome: false,
    showCancel: false,
  };

  let _rawSearch = window.location.search
  
  console.log('### raw location.search', _rawSearch)
  
  // ICP 回傳 URL 可能含兩個 '?'，將第二個換成 '&' 確保 URLSearchParams 解析正確
  const _secondQ = _rawSearch.indexOf('?', 1)
  if (_secondQ !== -1) _rawSearch = _rawSearch.substring(0, _secondQ) + '&' + _rawSearch.substring(_secondQ + 1)
  const queryString = _rawSearch
  $queryStr = queryString

  const urlParams = new URLSearchParams(queryString)
  const cipherText = urlParams.get('ct')
  const appVersion = urlParams.get('v')
  $appVer = appVersion
  // OPAPP 帶 state 參數返回（如 ICP 付款完成）時，跳過正常初始化流程直接分派
  const stateRouteHandled = routeByStateScene(urlParams)

  const appMode = urlParams.get('mode');
  $mode = appMode !== 'dev' && appMode !== 'demo' ? 'app' : appMode;
  $skipInfo = appMode === 'dev' ? false : $skipInfo;

  $:console.log('### $mode', $mode)

  if ($mode === 'dev') {
     // 開發模式使用預設配置
    $apiConfig.storageEndpoint = 'https://recyclecupteststorage.blob.core.windows.net'
  } else {
    $apiConfig.storageEndpoint = ''
    fetchAPIConfig();
  }

  //$:console.log('### $apiConfig', $apiConfig)

  if ($apiConfig.storageEndpoint) {
    appConfigJS = `${$apiConfig.storageEndpoint}/script-container/app-config.js?d=${new Date().getTime()}`;
  }

  //$:console.log('### appConfigJS',appConfigJS)
  //$:console.log('### API', API)

  function fetchAPIConfig() {
    fetch(`${API}/apiUrl`)
      .then(response => response.json())
      .then(d => {
        //console.log(d);
        $apiConfig = d;
        appConfigJS = `${$apiConfig.storageEndpoint}/script-container/app-config.js?d=${new Date().getTime()}`;
      });
  }
  
  /**
   * 載入系統開放設定後會觸發此事件
   */ 
  function onLoaded() {
    if (stateRouteHandled) return false;
    if (!appConfig) return false;

    //console.log('onLoaded', appConfig);
    $appSetting = appConfig;
    prepareMemberGID();
    if ($memberInfo.gid) render(); // 已有快取 GID 才先渲染；否則等 prepareMemberGID 取得後自行呼叫
  }

  // 開發模式直接渲染
  if ($mode === 'dev') {
    render();
  }

  /**
   * 渲染服務入口頁面
   */
  function render() {
    if (stateRouteHandled) {
      isBlock = false
      return
    }
    // 開發模式直接允許存取
    if ($mode === 'dev') {
      validate = true;
      $layoutOption.showCarousel = true;
      isBlock = false;
      return;
    }

    validate = $appSetting.isOpen && !$appSetting.isPause && $memberInfo.gid

    const isGuest = includedInList(appConfig.guestList)
    const isInBlock = includedInList(appConfig.blockList)

    console.log('is guest', isGuest)
    console.log('in block', isInBlock)
    
    if (!$memberInfo.gid) {
      setWarning(['取得會員資訊發生錯誤', '請稍候再試'])
      validate = false;
    } else if(isGuest) {
      validate = true;
    } else if (!appConfig.isOpen && !isGuest) {
      setWarning(['本服務尚未開放使用', '敬請期待'])
      validate = false;
    } else if (isInBlock) {
      setWarning(['本服務尚未開放使用', '敬請期待'])
      validate = false;
    } else if (appConfig.isOpen && !isGuest) {
      validate = !handlePausePeriod()
    }

    if (validate) {
      $layoutOption.showCarousel = true
    }

    isBlock = false
  }

  $:console.log('### validate', validate)

  /**
   * 判斷目前是否處於服務暫停期間
  */
  function handlePausePeriod() {
    const { beginTime, endTime } = appConfig.pauseInterval;
    const inPause = new Date(beginTime) < new Date() && new Date(endTime) > new Date()

    console.log('in pause=', inPause)

    if (inPause) {
      setWarning([`${beginTime} ~ ${endTime.substr(11, 5)}`, '系統維護，服務暫停，敬請見諒'])
    }

    return inPause
  }

  /**
   * 檢查會員GID是否存在於白名單/黑名單
  */
  function includedInList(list, gid = $memberInfo.gid) {
    if (!Array.isArray(list)) return false
    return list.includes(gid)
  }

  /**
   * 解析 URL state 參數（URL-encoded JSON），依 scene 分派對應處理器
   * OPAPP 在付款等外部流程完成後重新開啟 WebView 時會附帶此參數
   */
  function routeByStateScene(params) {
    const stateParam = params.get('state')
    if (!stateParam) return false

    let state
    try {
      state = JSON.parse(stateParam)
    } catch (e) {
      console.log('invalid state param', stateParam, e)
      return false
    }

    if (!state || !state.scene) return false

    const sceneHandlers = {
      icp_result: routeToIcpResult,
    }

    const sceneHandler = sceneHandlers[state.scene]
    if (!sceneHandler) return false

    sceneHandler(state, params)
    return true
  }

  /**
   * scene=icp_result：ICP AppToApp 付款完成，導至 /op-icp-result 頁顯示交易結果
   */
  function routeToIcpResult(state, params) {
    const nextParams = new URLSearchParams()
    if (state.orderId) nextParams.set('orderId', state.orderId)

    const tradeResultCode = params.get('TradeResultCode')
    const tradeResultMsg = params.get('TradeResultMsg')

    if (tradeResultCode !== null) nextParams.set('TradeResultCode', tradeResultCode)
    if (tradeResultMsg !== null) nextParams.set('TradeResultMsg', tradeResultMsg)

    const nextQuery = nextParams.toString()
    location.href = nextQuery ? `/op-icp-result?${nextQuery}` : '/op-icp-result'
  }

  function setWarning(messages) {
    console.log('messages=', messages)
    warning = { message: messages, small: [] }
  }

  /**
   * 認證雲路徑（cloudAuthEnabled=true 或在 guestList 白名單內時呼叫）。
   * 取新 authV → POST /inapp/cloud-auth → 一次取得 GID + foen + JWT。
   * authV 用完即丟，不寫進 memberInfo；失敗時拋錯由 prepareMemberGID 統一處理。
   */
  async function prepareCloudAuth(originalGid) {
    // 開發模式沒有 OPAPP bridge，維持既有 ct 認證流程。
    if ($mode === 'dev') {
      await initializeInappAuth()
      return
    }

    const authV = await getAuthVAsync()
    // 此時尚未取得 JWT，不能使用 inappFetch。
    const response = await fetch(`${$apiConfig.apiUrl}/inapp/cloud-auth?code=${$apiConfig.apiKey}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ authV })
    })

    if (!response.ok) {
      throw new Error(`CLOUD_AUTH_REQUEST_FAILED_${response.status}`)
    }

    const data = await response.json()
    const token = data?.info?.token
    if (!token) {
      throw new Error('CLOUD_AUTH_TOKEN_EMPTY')
    }

    // authV 僅用於本次請求，不寫入 memberInfo 或其他 store。
    $memberInfo.gid = data?.info?.gid || originalGid
    $memberInfo.foen = data?.info?.foen || ''
    setInappToken(token, { cipherTextValue: '' })
    $inappTokenSource = 'cloudAuth'
  }

  /**
   * 取得會員GID
   */
  async function prepareMemberGID() {
    try {
      const response = await fetch(`${$apiConfig.apiUrl}/decrypt?code=${$apiConfig.apiKey}`, {
        method: 'POST',
        body:JSON.stringify({cipherText : cipherText, appVersion : appVersion })
      })
      const d = await response.json()

      if(d.gid === '') {
          validate = false
          $layoutOption.showCarousel = false
          setWarning(['取得會員資訊發生錯誤', '請稍候再試'])
          isBlock = false
          return
      }
      //--如果會員GID與先前登入的GID不同，就一併清除記憶的手機號碼，以便後續能夠重新取得GID所對應的手機號碼
      $cipherTextStore = cipherText
      const originalGid = d.gid
      let gidChanged = $memberInfo.gid !== originalGid

      if (gidChanged) {
        $memberInfo.gid = originalGid
        $memberInfo.foen = ''
      }

      $memberInfo.authV = ''
      if (appConfig.cloudAuthEnabled || includedInList(appConfig.guestList, originalGid)) {
        // GID 未變、token 有效、且本身就是認證雲 session：跳過重取 authV（CC01）
        // 若前次走 ct 路徑（source='ct'），即使 token 仍有效也要重走認證雲（CG03）
        if (!gidChanged && hasValidToken() && $inappTokenSource === 'cloudAuth') {
          $inappTokenSource = 'cloudAuth'
        } else {
          await prepareCloudAuth(originalGid)
        }
      } else {
        $inappTokenSource = 'ct'
        await initializeInappAuth()
      }

      if (stateRouteHandled) return

      queryOrder()
      if (gidChanged) render()
    } catch (e) {
      console.log('prepareMemberGID error', e)
      validate = false
      $layoutOption.showCarousel = false
      setWarning(['取得會員資訊發生錯誤', '請稍候再試'])
      isBlock = false
    }
  }

  $:console.log('### gid', $memberInfo.gid)

  /**
   * 查詢訂單
   */
  function queryOrder() {
    inappFetch(`${$apiConfig.apiUrl}/inapp/order?code=${$apiConfig.apiKey}&gid=${$memberInfo.gid}&ct=${encodeURIComponent($cipherTextStore)}`, {
            method: 'GET'
        })
        .then(response => response.json())
        .then(d => {
              console.log(d)
              if(d.returnCode === '0000') {
                  let orders = d.info.filter(el=> el.payStatus > 0).filter(el=> el.orderStatusShort === '待退款')
                  needRefundCount = orders.length
              } 
        })
        .catch(e => {
            console.log(e)
        });
  }

  $:console.log('### needRefundCount', needRefundCount)

  try{
    screenLight(false)
  }catch(e){
    console.log(e)
  }

</script>

{#if (validate)}
  <div class="content-wrap">
    <div class="service">
        <span class="srv-p">循環杯服務</span>
        <hr>
    </div>
    <div class="mid-4">
        <div class="mid-4-icon">
            <btn class="item"  onclick="location.href='/op-auth'">
                <img class="hm-icon" src="/img/atom-button-menu-sub-menu-cup-rent.svg"
                    alt="">
                <span>登記借杯</span>
            </btn>
        </div>
        <div class="mid-4-icon">
            <btn class="item" onclick="location.href='/redeem'">
                <img class="hm-icon" src="/img/atom-button-menu-sub-menu-cup-take.svg"
                    alt="">
                <span>兌換取杯</span>
            </btn>
        </div>
        <div class="mid-4-icon">
            <btn class="item" onclick="location.href='/return-cup'">
                <img class="hm-icon" src="/img/atom-button-menu-sub-menu-cup-return-copy.svg" alt="">
                <span>還杯</span>
            </btn>
        </div>
        <div class="mid-4-icon">
            <btn class="item" onclick="location.href='/order?f=all&s=createtime'">
                <img class="hm-icon" src="/img/atom-button-menu-sub-menu-cup-receipt.svg"
                    alt="">
                <span>紀錄查詢</span>
            </btn>
        </div>
    </div>

    {#if (needRefundCount > 0)}
    <a href="/order?f=need_refund&s=createtime" class="error-wrap">
      <div class="error">
          <span>門市待退款{needRefundCount}筆，按下後進行門市退款</span>
          <img src="/img/atom-button-glyphs-buttons-direction-small-right-btn-arrow-right-w-n.svg" alt="">
      </div>
     </a>
    {/if}
  
    <div class="bd-hr-wrap">
        <hr>
    </div>

    <div style="position: relative; width: 100%; height: 0; padding-bottom: 56.25%;">
        <iframe src="https://www.youtube.com/embed/iVR528JaRyE?si=w7KNt6DMTzOHndfH" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe>
    </div>
  
    <div class="bd-hr-wrap">
        <hr>
    </div>
  
    <btn class="inquiry" onclick="location.href='/store?opbrowser=1'">
        <img class="i-img" src="/img/btn-lovefood-location-a.svg" alt="">
        <span class="i-p">查詢循環杯門市</span>
    </btn>
  
    <div class="iq-sm">
        <p>
          目前並非全台統一超商門市皆有循環杯租借服務，可點選上方查詢目前循環杯借杯/還杯門市服務據點。
          <br>點選<a href="/info" class="iq-sm-s-c"><span>租借說明</span></a>了解租借方式
          <br>循環杯客服專線 0809-090-711
        </p>
    </div>
  </div>
{:else}
  <Warning {warning}></Warning>
{/if}

<Loader {loader} {isBlock}></Loader>

<input type="hidden" id="sakura" value="off">

